import * as React from 'react';

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import Background1 from '../../../../../assets/images/background/onibus.jpg';


import { BaseComp, BannerImg, BannerText, BannerContent } from './styles';
import Typewriter from '../../../../TypingEffect';

interface INavBar {

}



const Banner: React.FC<INavBar> = () => {
    const navigate = useNavigate();

    const matches = useMediaQuery('(max-width:800px)');



    return (
        <BaseComp id='main'>
            <Typewriter texto="Setrabh, o seu parceiro de todas as horas!" tempoEscrita={100} tempoDuracao={2000} textSize={matches ? "26px" : "65px"} />
            <BannerContent>
                <BannerImg src={Background1} />
                <BannerText>
                    <p>
                        Quem vive em Belo Horizonte tem sempre uma história para contar sobre os ônibus da cidade.
                        Estamos presentes no dia a dia dos mineiros, levando e trazendo sonhos, desafios e conquistas. Assim como toda boa amizade, acreditamos que uma conversa sincera e aberta faz toda a diferença.
                    </p>
                    <p>
                        Foi por isso que criamos este site e outros canais de comunicação: para estarmos ainda mais próximos de você.
                    </p>
                </BannerText>
            </BannerContent>
        </BaseComp>
    );
}

export { Banner }